<div class="task-detail-page">
  <header class="task-detail-header">
    <div class="task-detail-title-row">
      <a
        class="lm-icon-btn"
        [routerLink]="backCommands()"
        [queryParams]="backQueryParams()"
        [attr.aria-label]="backLabel()"
        [attr.title]="backLabel()">
        <svg lucideArrowLeft class="lm-icon" aria-hidden="true"></svg>
      </a>
      <h1 class="text-title">{{ task()?.title ?? 'Task detail' }}</h1>
    </div>
    <p *ngIf="task() as task">Task checklist</p>
  </header>

  <section *ngIf="loading()" class="loading">Loading task detail…</section>

  <section *ngIf="error()" class="lm-notice lm-notice--danger">
    {{ error() }}
    <button type="button" class="lm-btn" (click)="retry()">Retry</button>
  </section>

  <ng-container *ngIf="!loading() && !error() && task() as task">
    <section class="task-items-section">
      <app-task-items [taskId]="task.id"></app-task-items>
    </section>
  </ng-container>
</div>
